export default "__VITE_ASSET__D$uJY$rv__"